import { Route, Switch } from 'react-router-dom'
import React, { Component } from 'react'
import Bed from './bed'
import Water from './cold-water'
import Electric from './electric/electric'
import NetworkFee from './network-fee/network-fee'
import HotWater from './hot-water'
import Deposit from './deposit'
import Bill from './bill/bill'
import BillDetail from './bill/bill-detail/bill-detail'
import AirConditionerFee from './air-conditioner-fee/air-conditioner-fee'
import PaymentRecord from './payment-record/payment-record'
import BasicList from './payment-record/basic-list/basic-list'
import ComplexList from './payment-record/complex-list/complex-list'
import Heating from './heating/heating'
import './payment.less'
import { setPaymentInfo } from '@/util/payment'
const AirConditioner = AirConditionerFee

export default class Payment extends Component {
  componentDidMount() {
    if (process.env.REACT_APP_ENV === 'development') {
      setPaymentInfo(JSON.stringify({ checkin_id: '59631', name: 'testName' }))
    } else {
      window.setPaymentInfo = setPaymentInfo
      if (window.WebViewBridge) {
        window.WebViewBridge?.userInfo?.call(window.WebViewBridge, 'setPaymentInfo')
      } else if (window.webkit) {
        window.webkit.messageHandlers.userInfo.postMessage('setPaymentInfo')
      }
    }
  }
  render() {
    const { match }: any = this.props
    return (
      <Switch>
        <Route exact path={`${match.path}/bed`} component={Bed} />
        <Route exact path={`${match.path}/cold-water`} component={Water} />
        <Route exact path={`${match.path}/electric`} component={Electric} />
        <Route exact path={`${match.path}/networkFee`} component={NetworkFee} />
        <Route exact path={`${match.path}/hot-water`} component={HotWater} />
        <Route exact path={`${match.path}/deposit`} component={Deposit} />
        <Route exact path={`${match.path}/heating`} component={Heating} />
        <Route
          path={`${match.path}/airconditioner`}
          component={AirConditioner}
        />
        <Route path={`${match.path}/record`} component={PaymentRecord} />
        <Route exact path={`${match.path}/bill/:index`} component={Bill} />
        <Route
          exact
          path={`${match.path}/bill-detail`}
          component={BillDetail}
        />
        <Route path={`${match.path}/basic-list`} component={BasicList} />
        <Route path={`${match.path}/complex-list`} component={ComplexList} />
      </Switch>
    )
  }
}
